module.exports = __webpack_public_path__ + "static/media/Mod.e21a7b47.jpg";